// Odds conversion utilities for parlay calculations

import { BetSlipItem } from './types';

export function americanToDecimal(odds: number): number {
  if (odds > 0) return 1 + odds / 100;
  return 1 + 100 / Math.abs(odds);
}

export function decimalToAmerican(dec: number): number {
  if (dec >= 2) return Math.round((dec - 1) * 100);
  return Math.round(-100 / (dec - 1));
}

export function americanToImpliedProb(odds: number): number {
  if (odds < 0) {
    return Math.abs(odds) / (Math.abs(odds) + 100);
  }
  return 100 / (odds + 100);
}

export interface ParlayCalculation {
  combinedOdds: number;
  trueProb: number | null;
  parlayEv: number | null;
}

export function calculateParlayStats(betSlip: BetSlipItem[]): ParlayCalculation {
  let combinedOdds = 0;
  let parlayEv: number | null = null;
  let trueProb: number | null = null;

  try {
    let decimalProduct = 1;
    let modelProbProduct = 1;
    let allLegsHaveModelWin = true;
    let allLegsHaveEv = true;

    for (const leg of betSlip) {
      const oddsNum = parseInt(leg.odds.replace('+', ''));
      if (isNaN(oddsNum)) throw new Error('Invalid odds');
      decimalProduct *= americanToDecimal(oddsNum);
      if (leg.modelWin !== null) {
        modelProbProduct *= leg.modelWin;
      } else {
        allLegsHaveModelWin = false;
      }
      if (leg.evPct === null) {
        allLegsHaveEv = false;
      }
    }

    combinedOdds = decimalToAmerican(decimalProduct);

    if (allLegsHaveModelWin) {
      trueProb = modelProbProduct * 100;
    }
    if (allLegsHaveModelWin && allLegsHaveEv) {
      // EV = (profit if win × P(win)) - (stake × P(lose))
      parlayEv = ((decimalProduct - 1) * modelProbProduct - (1 - modelProbProduct)) * 100;
    }
  } catch {
    // Fallback
  }

  return { combinedOdds, trueProb, parlayEv };
}
